import Vue from 'vue';
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT_REQUEST
} from './actionTypes';
import loginApi from '../../_api/login';
import router from '../../router';

const COOKIE_TOKEN = 'token';

function readCookie() {
  let value = document.cookie.match('(^|;)?' + COOKIE_TOKEN + '=([^;]*)(;|$)');
  return value ? unescape(value[2]) : null;
}

function setCookie(token) {
  document.cookie =
    COOKIE_TOKEN +
    '=' +
    escape(token) +
    ';path=/;expires=' +
    new Date('2030-01-01T01:00:00') +
    ';';
}

function destroyCookie() {
  document.cookie =
    COOKIE_TOKEN + '=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

const state = {
  status: '',
  isLoggedIn: !!readCookie(),
  token: readCookie()
};

const getters = {
  token: (state) => state.token
};

const actions = {
  [LOGIN_REQUEST]: ({ commit, dispatch }, payload) => {
    console.log('login action', payload);
    return new Promise((resolve, reject) => {
      commit(LOGIN_REQUEST);
      loginApi
        .getTokenFromLogin(payload)
        .then((response) => {
          commit(LOGIN_SUCCESS, response);
          resolve(response);
        })
        .then(() => {
          router.push('/');
          window.location.reload();
        })
        .catch((error) => {
          commit(LOGIN_ERROR, error);
          reject(error);
        });
    });
  },
  [LOGIN_ERROR]: ({ commit, dispatch }, payload) => {
    destroyCookie();
    commit(LOGIN_ERROR, payload);
  },
  [LOGOUT_REQUEST]: ({ commit, dispatch }, payload) => {
    console.log('logout action', payload);
    destroyCookie();
    router.push({ path: '/', replace: true });
    window.location.reload();
  },
  [LOGIN_SUCCESS]: ({ commit, dispatch }, payload) => {}
};

const mutations = {
  [LOGIN_REQUEST]: (state, response) => {
    state.status = 'loading';
  },
  [LOGIN_SUCCESS]: (state, response) => {
    state.status = 'success';
    Vue.set(state, 'isLoggedIn', true);
    Vue.set(state, 'token', response.data.token);
    setCookie(response.data.token);
  },
  [LOGIN_ERROR]: (state, response) => {
    state.status = 'error';
    Vue.set(state, 'token', null);
    Vue.set(state, 'isLoggedIn', false);
    Vue.set(state, 'errors', response.error);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
